export default __webpack_public_path__ + "static/media/Screenshot from 2024-08-12 18-39-49.4231a213.png";